<template>
  <nav class="navbar navbar-expand bg-light fixed-bottom justify-content-center" v-if="!this.allowToShow(['register','login','dispatch'])">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="unSelectable nav-link text-primary" :class="{'text-success':this.allowToShow(['home'])}" @click="switchToTab('home')">主页</a>
      </li>
      <li class="nav-item">
        <a class="unSelectable nav-link text-primary" :class="{'text-success':this.allowToShow(['cards'])}" @click="switchToTab('cards')">银行卡</a>
      </li>
      <li class="nav-item">
        <a class="unSelectable nav-link text-primary" :class="{'text-success':this.allowToShow(['rank'])}" @click="switchToTab('rank')">历史</a>
      </li>
      <li class="nav-item">
        <a class="unSelectable nav-link text-primary" :class="{'text-success':this.allowToShow(['profile'])}" @click="switchToTab('profile')">个人信息</a>
      </li>
    </ul>
  </nav>

</template>

<style scoped>
  a {
    cursor: pointer;
  }
  *, *:before, *:after {
    transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
  }
</style>

<script>
export default {
  name:'bottomBar',
  methods: {
    switchToTab:function(link){
      if('/'+link === this.$route.path) return null
      this.$router.push({path:`/${link}`,replace:true})
    },
    allowToShow:function(tabName){
      if(tabName.indexOf(this.$route.name) !== -1){
        return true
      }else{
        return false
      }
    }
  }
}
</script>

